// React
import React, { useContext } from "react";
// React
// CSS
import styles from "./UserLessonCard.module.css";
// CSS
import { Fade } from "react-awesome-reveal";
import { useNavigate } from "react-router-dom";
import { I_UserLesson } from "../../../Models/interfaces";
import { SetLessonDataContext } from "../../../Contexts/SetLessonDataContext";
import { _stringify } from "../../../Utils/_stringify";
import { SetAllDataNeededContext } from "../../../Contexts/AllDataNeededContext";
type UserLessonCardProps = {
  imgUrl: string;
  name: string;
  lessonId: string | number;
  lessonData: I_UserLesson;
  filter: string;
};

const UserLessonCard: React.FunctionComponent<UserLessonCardProps> = ({
  imgUrl,
  name,
  lessonId,
  lessonData,
  filter,
}) => {
  const navigate = useNavigate();
  const setLessonData = useContext(SetLessonDataContext);
  const setAllNeededData = useContext(SetAllDataNeededContext);

  return (
    <Fade
      className={`${styles.lessonCardContainer} bg-white p-4 flex flex-col items-center justify-center rounded-lg dark:!text-black`}
    >
      <div
        onClick={() => {
          if (!setLessonData) return;
          setAllNeededData((prevState) => ({
            ...prevState,
            lessonPictureUrl: lessonData.url,
          }));
          setLessonData((prevState) => ({ ...prevState, lessonName: name }));
          localStorage.setItem("lessonData", _stringify(lessonData));
          navigate(`/lesson/${lessonId}`, {
            state: lessonData,
          });
        }}
        className="flex flex-col items-center justify-center rounded-lg"
      >
        <img
          src={String(imgUrl)}
          alt=""
          style={{
            WebkitFilter: `opacity(.9) drop-shadow(0  ${filter})`,
            filter,
          }}
        />
        <p className="text-xs w-full text-center mt-4">{name}</p>
      </div>
    </Fade>
  );
};

export default UserLessonCard;
